import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ReviewSlider from "./ReviewsSlider/reviewsSlider";
import { GetReviews } from "../../actions/Reviews/Reviews";
const Reviews = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetReviews());
  }, []);

  return (
    <Row className="m-0 landingDiv d-flex justify-content-center pb-5  w-100">
      <Row className="d-flex justify-content-center align-items-center pt-5 pb-4  text_40 productSans">
        <Col
          xs={12}
          md={6}
          className="text-center ms-2 d-flex justify-content-center align-items-center
                 justify-content-md-end"
        >
          {t("ReviewsTitle")}
        </Col>
        <Col
          xs={12}
          md={5}
          className="landing_banner_Heading RalewayXBold
                d-flex justify-content-center align-items-center
                justify-content-md-start m-0 p-0 text-center"
        >
          {t("ReviewsTitleSpan")}
        </Col>
      </Row>
      <Row>
        <ReviewSlider />
      </Row>
    </Row>
  );
};

export default Reviews;
